import type { ScadaAnalysis, ScadaApply } from '../types/contract';

import { CTL_CONFIG_ENDPOINTS } from './endpoints';
import { ANALYSIS_TIMEOUT_MS, APPLY_TIMEOUT_MS, parsed, reportFailure, request } from './http';
import { scadaAnalysisSchema, scadaApplySchema } from './schemas';

export const fetchScadaAnalysis = async (plantId: string, signal?: AbortSignal): Promise<ScadaAnalysis> => {
  const raw = await request('get', CTL_CONFIG_ENDPOINTS.SCADA_ANALYSIS(plantId), { signal, timeoutMs: ANALYSIS_TIMEOUT_MS });
  return parsed(scadaAnalysisSchema, raw, 'SCADA analysis');
};

export const applyScadaAnalysis = async (plantId: string): Promise<ScadaApply> => {
  const raw = await request('post', CTL_CONFIG_ENDPOINTS.SCADA_APPLY(plantId), { timeoutMs: APPLY_TIMEOUT_MS });
  const applied = parsed(scadaApplySchema, raw, 'SCADA apply');
  const failed = applied.results.filter((result) => result.outcome === 'failed');
  if (failed.length > 0) {
    reportFailure(new Error('SCADA apply left machines unsaved'), { plantId, failed: failed.map(({ equipmentId, message }) => ({ equipmentId, message })) });
  }
  return applied;
};
